const firebaseConfig = {
  apiKey: 'AIzaSyBPS9sBLuX7ULxwqxVLI9e431w9ggmKiaM',
  authDomain: 'app.badenbatte.be',
  databaseURL: 'https://badenbattle-a0dec.firebaseio.com',
  projectId: 'badenbattle-a0dec',
  storageBucket: 'badenbattle-a0dec.appspot.com',
  messagingSenderId: '855454974300',
  appId: '1:855454974300:web:9904d0ea27239000038199',
  measurementId: 'G-9SGHK33E8H',
}

export { firebaseConfig }
